<template>
  <div class="question-item">
    <div class="company-title"><span>你的意向公司有哪些？（可多选）</span><span v-if="isEdit" @click="refresh" class="refresh"><i class="iconfont iconrefresh-ccw" style="margin-right: 4px"></i>换一换</span></div>
    <div class="company-list">
      <template v-if="isEdit">
        <div :class="['company-item', 'is-edit', selectList.map(obj => obj.name).includes(item.name) ? 'active' : '']" v-for="(item, index) in data" :key="index" @click="handleClickCompanyItem(item)" :style="{marginRight: (index + 1) % 5 == 0 ? '0px' : '22px'}">
          <img class="iconxuanzhong" src="https://files.wondercv.com/PC/cvs/planning/company/xuanzhong.png" width="14" height="14"/>
          <div class="img-box">
            <img :src="item.logo" alt="" width="40" height="40">
          </div>
          <p>{{item.name}}</p>
        </div>
      </template>
      <template v-else>
        <div :class="['company-item', 'not-hover']" v-for="(item, index) in selectList" :key="index" :style="{marginRight: (index + 1) % 5 == 0 ? '0px' : '22px'}">
          <img class="iconxuanzhong" src="https://files.wondercv.com/PC/cvs/planning/company/xuanzhong.png" width="14" height="14"/>
          <div class="img-box">
            <img :src="item.logo" alt="" width="40" height="40">
          </div>
          <p>{{item.name}}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import api from "../../../api/index"
  export default {
    name: "company-select",
    props:{
      value:{
        type: [String, Array]
      },
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    model:{
      prop: 'value',
        event: 'change'
    },
    data(){
      return {
        selectList: [],
        data: []
      }
    },
    created() {
      this.getRandomCompany()
    },
    mounted() {
      this.selectList = this.value
    },
    methods:{
      handleClickCompanyItem(item){
        if (this.selectList.map(obj => obj.name).includes(item.name)){
          this.selectList = this.selectList.filter(name => item.name != name.name)
        }else{
          this.selectList.push(item)
        }
        this.$emit("change",this.selectList)
      },
      getRandomCompany(){
        api.planning.getRandomCompany().then(res=>{
          if(res.code === 1000){
            this.data = [...res.data.big_company, ...res.data.middle_company, ...res.data.small_company]
          }
        })
      },
      refresh(){
        // this.selectList = []
        this.getRandomCompany()
      }
    },
    watch:{
      value(value){
        this.selectList = value
      }
    }
  }
</script>

<style scoped lang="scss">
  .question-item{
    margin-bottom: 82px !important;
    .company-title{
      font-size: 13px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 18px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      &>span{
        cursor: pointer;
      }
      .iconfont{
        color: #669BFF;
      }
      .refresh:hover{
        color: #FFFFFF;
      }
    }

    .company-list{
      display: flex;
      flex-wrap: wrap;
      .company-item{
        width: 47px;
        height: 47px;
        cursor: pointer;
        position: relative;
        margin-right: 22px;
        margin-bottom: 22px;
        & > .iconxuanzhong{
          position: absolute;
          top: -3px;
          right:-3px;
          font-size: 14px;
          color: #fff;
          z-index: 2;
          display: none;
          border: 2px solid #252a34;
          border-radius: 50%;
        }
        &.active .img-box{
          border-color: #fff;
        }
        &.is-edit:hover .img-box{
          border-color: #fff;
        }
        &.active .iconxuanzhong{
          display: block;
        }
        .img-box{
          width: 48px;
          height: 48px;
          border: 1px solid transparent;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          position: relative;
          z-index: 1;
          & > img{
            width: 40px;
            height: 40px;
            border-radius: 5px;
          }
        }
        & > p{
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.4);
          line-height: 17px;
          text-align: center;
          width: 48px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
      }
    }
  }
</style>
